import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hidden lg:block w-next-nav fixed h-menu bg-next-dark-gray z-10" }
const _hoisted_2 = { class: "grid grid-rows-7 h-full" }
const _hoisted_3 = { class: "flex-grow grid grid-rows-6 row-span-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_ProfileMenuButton = _resolveComponent("ProfileMenuButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_MenuButton, {
        to: {name:'Home', params: {id: _ctx.id}},
        "icon-class": "icon-home",
        tooltip: "Home"
      }, null, 8, ["to"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_MenuButton, {
          to: {name:'ListaProgetti'},
          "icon-class": "icon-catena_orizzontale",
          tooltip: "Progetti"
        }),
        _createVNode(_component_MenuButton, {
          to: {name:'DettaglioProgetto', params: {id: _ctx.id}},
          "icon-class": "icon-catena_verticale",
          tooltip: "Sottoprogetti"
        }, null, 8, ["to"]),
        _createVNode(_component_ProfileMenuButton, {
          class: "row-start-6",
          notification: _ctx.meCounters?.notification_counter > 0
        }, null, 8, ["notification"])
      ])
    ])
  ]))
}